import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle
} from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import Botao from '../Mantine/Botao'

import * as S from './styles'

const config = require('../../configuracoes.json')

const { recaptcha } = config

const RecaptchaComponent = forwardRef(
  (
    { login, close, theme = null, hasButton = true, componentType = 'modal', onSuccess = () => {} },
    ref
  ) => {
    const recaptchaRef = useRef()
    const [disableConnect, setDisableConnect] = useState(true)
    const [token, setToken] = useState(null)

    const handleSubmit = () => {
      setToken(recaptchaRef.current?.getValue())
      setDisableConnect(false)
      onSuccess(recaptchaRef.current?.getValue())
    }

    useImperativeHandle(
      ref,
      () => ({
        getToken: () => token,
        reset: () => {
          recaptchaRef.current?.reset()
          setToken(null)
          setDisableConnect(true)
        }
      }),
      [token]
    )

    const handleConnect = async () => {
      if (!token) {
        alert('Por favor, complete o reCAPTCHA.')
        return
      }

      login({ token: token, method: 'manual-recaptcha' })
    }

    const grecaptchaObject = window.grecaptcha
    window.recaptchaOptions = {
      useRecaptchaNet: true,
      enterprise: true
    }

    useEffect(() => {
      if (componentType === 'modal') {
        const timer = setTimeout(
          () => {
            close()
          },
          2 * 60 * 1000
        )

        return () => clearTimeout(timer)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
      <S.RecaptchaWrapper>
        <S.RecaptchaForm>
          <ReCAPTCHA
            ref={recaptchaRef}
            onChange={handleSubmit}
            onExpired={() => {
              recaptchaRef.current.reset()
              setToken(null)
            }}
            sitekey={recaptcha.siteKey}
            hl="pt"
            grecaptcha={grecaptchaObject}
            theme={
              theme ||
              (localStorage.getItem('tema') === 'escuro' ? 'dark' : 'light')
            }
          />
          {hasButton && (
            <Botao
              disabled={disableConnect}
              label="Entrar"
              onClick={handleConnect}
            />
          )}
        </S.RecaptchaForm>
      </S.RecaptchaWrapper>
    )
  }
)

RecaptchaComponent.displayName = 'RecaptchaComponent'
export default RecaptchaComponent
